import React from 'react'

function RedButton({
  onClick,
  ariaLabel,
  text,
  className,
  large,
  icon,
  disabled=false
}) {
  return (
  <div className={`${className} min-w-144`}>
      <button onClick={onClick} disabled={disabled} aria-label={ariaLabel} 
        className={`text-white flex justify-center items-center ${disabled && 'bg-gray-400'} ${!disabled && 'bg-green-600'} border rounded ${!disabled && 'hover:bg-green-500'} ${!large &&  'py-1.5 px-2'} ${large && 'py-3 px-2 text-lg'} w-full`}>
          {icon &&
          <div className='mr-1'>
            {icon}
          </div>}
          {text}
      </button>
    </div>
  )
}

export default RedButton
